import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { MessageThread } from '@/features/Messages/MessageThread';
import { useOrgThread, useSendMessage } from '@/lib/hooks/useMessages';

export function MessagesDialog({
  studentId, studentName, open, onOpenChange,
}: {
  studentId: string;
  studentName: string;
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const { data, isLoading } = useOrgThread(studentId, open);
  const send = useSendMessage(['messages', 'org', studentId]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader><DialogTitle>Message {studentName}</DialogTitle></DialogHeader>
        <MessageThread
          messages={data?.messages ?? []}
          self={data?.self ?? ''}
          loading={isLoading}
          sending={send.isPending}
          onSend={(body) => send.mutate({ student_id: studentId, body })}
          emptyText={`Start a conversation with ${studentName}.`}
        />
      </DialogContent>
    </Dialog>
  );
}
